import { useContext } from "react"

import { tableContext } from "../utils"

export function useHeader() {
  const { headers } = useContext(tableContext)

  return { headers }
}
